import { RadioButton, RadioButtonTrueFalse } from "Components/Form/RadioButton";

import { Input } from "Components/Form/Input";
import { InputMode } from "Components/Form/Input/inputTypes";
import { useTexts } from "Components/TextContext/";
import { OptionLabel } from "Components/TextContext/commonComponentEnums";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { AdditionalBuildingFormValues } from "../additionalBuildingsInterfaces";

interface Props {
  formProps: FormikProps<AdditionalBuildingFormValues>;
}

export const AnnexFormFields = ({ formProps }: Props): React.ReactElement => {
  const { getText, getRadioOptions } = useTexts();

  return (
    <>
      <Input
        large
        id="additionalBuilding_boa"
        name="additionalBuilding_boa"
        label={getText("additionalbuildings.label.bra")}
        hint={getText("additionalbuildings.hint.bra")}
        error={getError("additionalBuilding_boa", formProps)}
        inputProps={{ maxLength: 4 }}
        inputMode={InputMode.NUMERIC}
      />
      <RadioButtonTrueFalse
        direction="vertical"
        name="additionalBuilding_hasTapWater"
        id="additionalBuilding_hasTapWater"
        label={getText("additionalbuildings.label.hastapwater")}
        error={getError("additionalBuilding_hasTapWater", formProps)}
        options={[
          {
            id: "additionalBuilding_hasTapWater-yes",
            label: getText(OptionLabel.BOOLEAN_YES),
            value: true,
          },
          {
            id: "additionalBuilding_hasTapWater-no",
            label: getText(OptionLabel.BOOLEAN_NO),
            value: false,
          },
        ]}
      />
      <RadioButtonTrueFalse
        direction="vertical"
        name="additionalBuilding_hasElectricity"
        id="additionalBuilding_hasElectricity"
        label={getText("additionalbuildings.label.haselectricity")}
        error={getError("additionalBuilding_hasElectricity", formProps)}
        options={[
          {
            id: "additionalBuilding_hasElectricity-yes",
            label: getText(OptionLabel.BOOLEAN_YES),
            value: true,
          },
          {
            id: "additionalBuilding_hasElectricity-no",
            label: getText(OptionLabel.BOOLEAN_NO),
            value: false,
          },
        ]}
      />
      <RadioButton
        name="additionalBuilding_standard"
        id="additionalBuilding_standard"
        hint={getText("additionalbuildings.hint.additionalbuilding_standard")}
        label={getText("additionalbuildings.label.additionalbuilding_standard")}
        options={getRadioOptions(
          TextComponentNameLevel1.ADDITIONAL_BUILDINGS,
          "additionalBuilding_standard",
        )}
        direction="vertical"
        error={getError("additionalBuilding_standard", formProps)}
      />
    </>
  );
};
